<template>
    <widget-card
        title="Monster Types"
        :loading="loading"
        :error="error"
        :empty="!loading && (!payload || payload.length === 0)"
        :hidden="hidden"
        @retry="fetchData"
    >
        <table v-if="payload && payload.length" class="t" :class="{ 'is-dark': $vuetify.theme.dark }">
            <thead><tr><th>Monster</th><th>Encs</th><th>Max</th></tr></thead>
            <tbody>
                <tr v-for="row in payload" :key="row.monsterKeyId" @click="goToMonster(row.monsterKeyId)">
                    <td>{{ row.name }}</td>
                    <td>{{ row.encounterCount }}</td>
                    <td class="num">{{ row.totalMaxQuantity }}</td>
                </tr>
            </tbody>
        </table>
    </widget-card>
</template>

<script>
import api from '@/api'
import WidgetCard from './WidgetCard.vue'

export default {
    name: 'MonsterTypesWidget',
    components: { WidgetCard },
    props: {
        eventId: { type: Number, default: null },
        mode: { type: String, default: 'mine' },
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { loading: false, error: null, payload: null, hidden: false, inFlightKey: null }
    },
    watch: {
        eventId: { handler: 'fetchData', immediate: true },
        mode: 'fetchData',
        refreshKey: 'fetchData',
    },
    methods: {
        endpointUrl() {
            const m = this.mode.charAt(0).toUpperCase() + this.mode.slice(1)
            return `dashboard/monsterTypes/${this.eventId}?mode=${m}`
        },
        async fetchData() {
            if (!this.eventId) { this.payload = null; return }
            const key = `${this.eventId}|${this.mode}`
            this.inFlightKey = key
            this.loading = true; this.error = null; this.hidden = false
            try {
                const data = await api.get(this.endpointUrl())
                if (this.inFlightKey !== key) return
                this.payload = data
            } catch (err) {
                if (this.inFlightKey !== key) return
                if (err.response && err.response.status === 403) { this.hidden = true; return }
                this.error = err
            } finally {
                if (this.inFlightKey === key) this.loading = false
            }
        },
        goToMonster(id) {
            this.$router.push({ name: 'readMonster', params: { id } })
        },
    },
}
</script>

<style scoped>
.t { width: 100%; font-size: 12px; border-collapse: collapse; cursor: pointer; }
.t th, .t td { padding: 4px; text-align: left; border-bottom: 1px dotted #ddd; }
.t tr:hover td { background: rgba(25,118,210,0.04); }
.num { color: #1976d2; font-weight: 600; }
.t.is-dark th, .t.is-dark td { border-bottom-color: rgba(255,255,255,0.18); }
</style>
